// This is a request. File location /src/store/requests/song.js
import { URL_SONG } from "../../utilities/constants";

export const fetchSongDetail = async (songId) => {
    // console.log('fetch song api')
    
    const response = await fetch(URL_SONG(songId), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user_id: 0 }),
    })
    
    if (!response.ok) {
        const errorResponse = await response.json();
        // console.log('ERROR THROW: ', errorResponse.message);
        throw new Error(errorResponse.message)
    }

    const resData = await response.json();
    // console.log('songs response')
    // console.log(resData.data.song)

    return resData.data.song;
}